import React from 'react';
import { cn } from '../../lib/cn';

/** The id every shell puts on its <main>, and the target of the skip link. */
export const MAIN_ID = 'shell-main';

/**
 * Skip to content.
 *
 * First focusable thing in every shell. Off screen until it is focused, then a
 * real visible control, never `display: none`, which would take it out of the
 * tab order and make it useless.
 *
 * The prefix follows the track, because a `dsk-*` class must never appear in a
 * mobile view or the other way round.
 *
 * @param {{ track?: 'desktop'|'mobile', targetId?: string, className?: string }} props
 */
export function SkipLink({ track = 'desktop', targetId = MAIN_ID, className }) {
  const prefix = track === 'desktop' ? 'dsk' : 'ds';
  return (
    <a href={`#${targetId}`} className={cn(`${prefix}-skiplink`, className)}>
      Skip to content
    </a>
  );
}

export default SkipLink;
